import PaginationOutput from '@/helpers/PaginationOutput';
import { statsApi } from '@/api/stats';
import StatsStoreDailyVM from '@/view-model/StatsStoreDailyVM';
import StatsStoreMonthlyVM from '@/view-model/StatsStoreMonthlyVM';
import StatsStoreHourlyVM from '@/view-model/StatsStoreHourlyVM';
import StatsStoreDayOfWeekVM from '@/view-model/StatsStoreDayOfWeekVM';
import StatsStoreShareStoreVM from '@/view-model/StatsStoreShareStoreVM';
import StatsHubDailyVM from '@/view-model/StatsHubDailyVM';
import StatsHubMonthlyVM from '@/view-model/StatsHubMonthlyVM';
import StatsHubHourlyVM from '@/view-model/StatsHubHourlyVM';
import StatsHubDayOfWeekVM from '@/view-model/StatsHubDayOfWeekVM';
const apiMap = {
    store: {
        daily: (data) => statsApi.getStoreStatsDaily(data),
        monthly: (data) => statsApi.getStoreStatsMonthly(data),
        hourly: (data) => statsApi.getStoreStatsHourly(data),
        dayOfWeek: (data) => statsApi.getStoreStatsDayOfWeek(data),
        shareStore: (data) => statsApi.getStoreStatsShared(data),
    },
    hub: {
        daily: (data) => statsApi.getHubStatsDaily(data),
        monthly: (data) => statsApi.getHubStatsMonthly(data),
        hourly: (data) => statsApi.getHubStatsHourly(data),
        dayOfWeek: (data) => statsApi.getHubStatsDayOfWeek(data),
    },
};
const entityMap = {
    store: {
        daily: StatsStoreDailyVM,
        monthly: StatsStoreMonthlyVM,
        hourly: StatsStoreHourlyVM,
        dayOfWeek: StatsStoreDayOfWeekVM,
        shareStore: StatsStoreShareStoreVM,
    },
    hub: {
        daily: StatsHubDailyVM,
        monthly: StatsHubMonthlyVM,
        hourly: StatsHubHourlyVM,
        dayOfWeek: StatsHubDayOfWeekVM,
    },
};
/**
 * 통계 서비스 레이어 (상점, 허브)
 */
export const statsService = {
    /**
     * 상점, 허브 데일리 통계 조회
     */
    async getStats(serviceData) {
        const api = apiMap[serviceData.resourceType][serviceData.statsType];
        const entity = entityMap[serviceData.resourceType][serviceData.statsType];
        const response = await api(serviceData.createReqBody());
        return PaginationOutput.adaptorFactory(response, entity);
    },
};
